(function($) {  
  $(document).ready(function() {

    initAddToCart();
    initAddToCart2();
    qtyProduct();
    updateMiniCart();
    checkItemsInMiniCart();
  }); 

  function convertToSlug(text) {
    return text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
  } window.convertToSlug=convertToSlug;

  function showPopup(selector) {
    $(selector).addClass('active');
  } window.showPopup=showPopup;

  function hidePopup(selector) {
    $(selector).removeClass('active');
  } window.hidePopup=hidePopup;

  /* ADD TO CART */
  function doAjaxAddToCart(variant_id, quantity, title, image) {

    $.ajax({
      type: "post",
      url: "/cart/add.js",
      data: 'quantity=' + quantity + '&id=' + variant_id,
      dataType: 'json', 
      beforeSend: function() {              
        showPopup('.loading');  
      },
      success: function(msg) {   
        $('.product-popup').removeClass('wishlist-popup').addClass('cart-popup');
        $('.product-popup').find('.product-name').html(title);
        $('.product-popup').find('.product-image img').attr('src', image);

        showPopup('.product-popup');
        updateMiniCart();

      },
      error: function(xhr, text) {
        hidePopup('.loading'); 
        $('.error-message').text($.parseJSON(xhr.responseText).description);
        showPopup('.error-popup');
      }
    });
  }window.doAjaxAddToCart=doAjaxAddToCart;


  /* --------------------------------------------------------- */
  /* Ajax AddtoCart */



  /* Product item - Add To Cart */

  function initAddToCart() {
    $('.btn-addToCart').click(function(event) {    

      event.preventDefault();
      if ($(this).attr('disabled') != 'disabled') {

        var productItem = $(this).parents('.product-inner');
        var productId = $(productItem).attr('data-id'); 
         var form = $(this).parent(); 

        productId = productId.match(/\d+/g);

        var variant_id = $('.AddToCartForm-' + productId + ' select[name=id]').val();
        if (!variant_id) {
          variant_id = $('.AddToCartForm-' + productId + ' input[name=id]').val();
        }

        var quantity = $('.AddToCartForm-' + productId + ' input[name=quantity]').val();
        if (!quantity) {
          quantity = 1;
        }

        var title = $(productItem).find('.product-name').html();
        var image = $(productItem).find('.product-featured-image').attr('src');




        $.ajax({
          type: "post",
          url: "/cart/add.js",
          data: 'quantity=' + quantity + '&id=' + variant_id,
          dataType: 'json', 
          beforeSend: function() {              
            form.html('<div class="loader"><i class="icon-arrows-rotate-anti-dashed"></i></div>');
          },
          success: function(msg) {   
            $('.tooltip').remove();
            form.html('<a class="btn-added  product-add-cart" data-toggle="tooltip" data-placement="left" title="Added to basket !" href="/cart" ><i class="icon-ecommerce-bag-check"></i></a>');                                   
             $('[data-toggle="tooltip"]').tooltip({container: 'body'});
            updateMiniCart();

          },
          error: function(xhr, text) {
            hidePopup('.loading'); 
            $('.error-message').text($.parseJSON(xhr.responseText).description);
            showPopup('.error-popup');
          }
        });


      }
      return false;
    });
  }window.initAddToCart=initAddToCart;


  function initAddToCart2() {
    $('.btn-addToCart2').click(function(event) {

      event.preventDefault();
      if ($(this).attr('disabled') != 'disabled') {

        var productItem = $(this).parents('.product-inner-fix');
        var productId = $(productItem).attr('id');           

        productId = productId.match(/\d+/g);


        var variant_id = $('#productSelect').val();
        if (!variant_id) {
          variant_id = $('#productSelect').val();
        }

        var quantity = $('.product-single-quantity input[name=quantity]').val();
        if (!quantity) {
          quantity = 1;
        }



        var title = $(productItem).find('.product-name').html();
        var image = $(productItem).find('.more-views .owl-item.active img').attr('src');
        doAjaxAddToCart(variant_id, quantity, title, image); 
      }
      return false;
    });
  }window.initAddToCart=initAddToCart2;


  /* Update Mini Cart */
  function updateMiniCart() {
    Shopify.getCart(function(cart) {        
      doUpdateMiniCart(cart);
    });
  }window.updateMiniCart=updateMiniCart;

  /* Do Update Mini Cart */
  function doUpdateMiniCart(cart) {
    $('.number-cart').html(cart.item_count);
    var template = '<li class="item" id="cart-item-{id}"><a title="Remove this item" class="remove" href="#">×</a><a href="{url}" class="thumb-product"><img src="{img}" alt="{title}"></a><div class="widget-cart-title-product"><a href="{url}">{title}</a><span class="quantity">Quantity: {quantity}</span><span class="amount">{price}</span></div></li>';

    $('.total .amount').html(Shopify.formatMoney(cart.total_price, window.money_format)); 
    $('.cart_list.product_list_widget').html('');

    if (cart.item_count > 0) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = template;
        item = item.replace(/\{id\}/g, cart.items[i].id);
        item = item.replace(/\{url\}/g, cart.items[i].url);
        item = item.replace(/\{title\}/g, cart.items[i].title);
        item = item.replace(/\{quantity\}/g, cart.items[i].quantity);
        item = item.replace(/\{img\}/g, Shopify.resizeImage(cart.items[i].image, 'small'));
        item = item.replace(/\{price\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
        $('.cart_list.product_list_widget').append(item);
      }
      $('.cart_list .remove').click(function(event) {          
        event.preventDefault();       
        var productId = $(this).parents('.item').attr('id');
        productId = productId.match(/\d+/g);

        Shopify.removeItem(productId, function(cart) {
          doUpdateMiniCart(cart);
        });          
      });

    } 
    checkItemsInMiniCart();
  }window.doUpdateMiniCart=doUpdateMiniCart;

  /* Check Item Mini Cart */
  function checkItemsInMiniCart() {  


    if($('.cart_list.product_list_widget').children().length > 0) {

      $('.widget_shopping_cart_content').removeClass('noItem'); 

    } else{
      $('.widget_shopping_cart_content').addClass('noItem'); 

    }
  }window.checkItemsInMiniCart=checkItemsInMiniCart;

  function qtyProduct() { 
    $('.qtyplus').click(function(e){  
      var fieldName = $(this).attr('data-field');
      var currentVal = parseInt($('input[name='+fieldName+']').val());

      if (!isNaN(currentVal)) {
        $('input[name='+fieldName+']').val(currentVal + 1);
      } else {
        $('input[name='+fieldName+']').val(1);
      }
      e.preventDefault();
    });

    $(".qtyminus").click(function(e) {

      var fieldName = $(this).attr('data-field');
      var currentVal = parseInt($('input[name='+fieldName+']').val());
      if (!isNaN(currentVal) && currentVal > 1) {
        $('input[name='+fieldName+']').val(currentVal - 1);    } 
      else {
        $('input[name='+fieldName+']').val(1);
      }
      e.preventDefault();
    });
  }window.qtyProduct=qtyProduct;


})(jQuery);

